



















import Vue, { VueConstructor } from 'vue';

export default (Vue as VueConstructor<Vue & {

}>).extend({
  name: 'PageTitle',
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: false,
      default: null,
    },
  },
});
